var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1022.9 458.5",
    style: {
      enableBackground: "new 0 0 1022.9 458.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002ABE;}\r\n\t.st1{fill:#05AA3C;}\r\n\t.st2{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.4,261h-44l-10.4,27.4h-24.2l46.1-117.7h10.4c7.3,0,12.2,3.4,14.8,10.1l41.9,107.6h-24.2L423.4,261z  M385.5,241.5h31.6l-15.6-42.4h-0.2L385.5,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.9,170.7h23.2v48.6h54.8v-48.6h23.2v117.7h-23.2v-48.9h-54.8v48.9h-23.2L468.9,170.7L468.9,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.4,284.1c-3-2.9-4.5-6.6-4.5-11.4v-102h23.2v97.5h63.9v20.2h-70.8C602.4,288.4,598.4,287,595.4,284.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.3,171.6h56.2c8.6,0,15.5,2.4,20.8,7.3s7.9,11.3,7.9,19.2v17.1c0,8.5-2.8,15.4-8.5,20.6 c-5.6,5.2-13,7.9-22.2,7.9h-41.9v43.9h-12.3L712.3,171.6L712.3,171.6z M766.2,232.7c5.6,0,10.2-1.6,13.6-4.9 c3.4-3.3,5.1-7.6,5.1-13v-17.1c0-4.5-1.5-8.2-4.6-11c-3-2.8-7.1-4.2-12.2-4.2h-43.6v50.2H766.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M870.6,255.4h-50.9l-11.9,32.1h-12.6l44.6-116h5.6c3.6,0,6.3,2.2,8,6.6l25.5,67h0.2v0.3l16.1,42.1h-12.6 L870.6,255.4z M823.5,245.1h43.3l-21.5-57.7H845L823.5,245.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M927.3,243l-42.8-71.4h13.3l35.6,60.3l35.6-60.3h13.3L939.5,243v44.6h-12.3V243z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,347.2l56.9-0.4c0.1,0,0.1,0,0.1-0.1l-37.8-67.5l-29.3,50.6C40.7,337.6,46.3,347.3,55.3,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,229.4l76.3,0.2l0,0l0,0l64.2,111.3c2.1,3.7,6.1,6,10.3,6h44.8c9.2,0,14.9-9.9,10.3-17.9l-94.4-163.5 l-27-46.8c-4.6-8-16.1-8-20.7,0L103,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.3,238.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.8,213.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.3,240.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,229.4c-9.2,0-15,10-10.4,18l19.5,33.6l36.4,65l0.5,1l67-117.3l-76.3-0.2L66.3,229.4L66.3,229.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV2);
export default __webpack_public_path__ + "static/media/logo_v2.9708ddb4f2114a85c56d8b77f460d406.svg";
export { ForwardRef as ReactComponent };